import axios from 'axios';
//import router from '../router'
import store from '@/store';
import axiosRetry from 'axios-retry';
import Toast from '@/packages/toast/index.js';
// create an axios instance
const service = axios.create({
	timeout: 50000 // request timeout
});

axiosRetry(service, {
	retries: 100,
	shouldResetTimeout: true,
	retryDelay: () => {
		return 5000;
	}
});
// request interceptor
service.interceptors.request.use(
	(config) => {
		if (store.state.app.domain) {
			config.baseURL = 'https://' + store.state.app.domain;
		}
		// Do something before request is sent
		return config;
	},
	(error) => {
		// Do something with request error
		// console.log(error) // for debug
		Promise.reject(error);
	}
);

// respone interceptor
service.interceptors.response.use(
	(response) => {
		if (response.data.code != 0 && response.data.code != 6000) {
			if (response.config.url.indexOf('GetEntrance') > -1) {
				const lang = store.state.app.lang;
				const errMsg =
					lang == 'cn' ? '您的连接已过期，请关闭页面，重新登入。' : 'Session expired. Please close the page and Login Again！';
				Toast.service(errMsg);
			} else {
				Toast.service(response.data.msg);
			}
		}
		return response;
	},
	(error) => {
		//Toast.service(error)
		return Promise.reject(error);
	}
);

export default service;
